import React, { useState, useRef } from "react";
import { adminUpdateCompany } from "../../../services/CompanyService";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import ReactInputMask from "react-input-mask";
import removerSpecialChars from "../../../util/StringUtils";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";

export const EditarEmpresa = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(
    new Date(props.company.subscriptionEndDate + " 00:00:00")
  );
  
  const inputCnpj = useRef("");
  const inputCorporateName = useRef("");
  const inputFantasyName = useRef("");
  const inputAddress = useRef("");
  const inputWhatsAppNumber = useRef("");
  const toggle = () => setIsOpen(!isOpen);

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      id: props.company.id,
      documentNumber: removerSpecialChars(inputCnpj.current.value),
      corporateName: inputCorporateName.current.value,
      fantasyName: inputFantasyName.current.value,
      address: inputAddress.current.value,
      whatsAppNumber: removerSpecialChars(inputWhatsAppNumber.current.value),
      subscriptionEndDate: dayjs(subscriptionEndDate).format("YYYY-MM-DD"),
    };

    adminUpdateCompany(data)
      .then((response) => {
        props.listCompanies(false);
        toast.success(response);
        setIsOpen(false);
      })
      .catch((error) => {
        console.error("[updateCompany] ", error);
        toast.error("Não foi possível atualizar dados da empresa");
      });
  }

  return (
    <div>
      {/* Gatilho no Dropdown */}
      <button
        onClick={() => setIsOpen(true)}
        type="button"
        className="dropdown-item py-2 d-flex align-items-center"
      >
        <i className="fas fa-edit me-2 text-muted"></i>
        Editar dados
      </button>

      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        backdrop="static"
        size="lg"
        centered
      >
        {/* Cabeçalho Limpo com Título Preto (Padrão Premium) */}
        <ModalHeader toggle={toggle} className="border-0 pb-0 pt-4 px-4">
          <h5 className="fw-bold text-dark mb-0">Editar Empresa</h5>
          <p className="text-muted small mb-0 mt-1">Gerencie a assinatura e revise as informações da empresa cadastrada</p>
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="px-4 pt-3 pb-4">
            
            {/* SEÇÃO 1: DADOS CADASTRAIS (CARD LIGHT - APENAS LEITURA) */}
            <div className="bg-light p-3 rounded-4 border mb-4">
              <div className="d-flex align-items-center mb-3 text-muted">
                <i className="fas fa-lock me-2"></i>
                <span className="fw-bold small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Informações Cadastrais (Apenas Leitura)
                </span>
              </div>
              
              <div className="row g-3">
                <div className="col-lg-12">
                  <label htmlFor="razaoSocial" className="form-label small fw-bold text-dark mb-2">Razão Social</label>
                  <input
                    ref={inputCorporateName}
                    defaultValue={props.company.corporateName}
                    type="text"
                    id="razaoSocial"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    disabled
                    required
                  />
                </div>

                <div className="col-lg-6">
                  <label htmlFor="nomeFantasia" className="form-label small fw-bold text-dark mb-2">Nome Fantasia</label>
                  <input
                    ref={inputFantasyName}
                    defaultValue={props.company.fantasyName}
                    type="text"
                    id="nomeFantasia"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    disabled
                    required
                  />
                </div>

                <div className="col-lg-6">
                  <label htmlFor="cnpj" className="form-label small fw-bold text-dark mb-2">CNPJ</label>
                  <ReactInputMask
                    ref={inputCnpj}
                    defaultValue={props.company.documentNumber}
                    type="text"
                    id="cnpj"
                    mask="99.999.999/9999-99"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    required
                    disabled
                  />
                </div>

                <div className="col-lg-12">
                  <label htmlFor="address" className="form-label small fw-bold text-dark mb-2">Endereço</label>
                  <input
                    defaultValue={props.company.address}
                    ref={inputAddress}
                    type="text"
                    id="address"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    disabled
                    required
                  />
                </div>

                <div className="col-lg-12">
                  <label htmlFor="whatsAppNumber" className="form-label small fw-bold text-dark mb-2">WhatsApp Comercial</label>
                  <ReactInputMask
                    defaultValue={props.company.whatsAppNumber}
                    ref={inputWhatsAppNumber}
                    type="text"
                    id="whatsAppNumber"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                    mask="(99) 99999-9999"
                    required
                    disabled
                  />
                </div>
              </div>
            </div>

            {/* SEÇÃO 2: GERENCIAMENTO DE LICENÇA (CARD WHITE COM SOMBRA - ATIVO) */}
            <div className="bg-white p-3 rounded-4 border shadow-sm" style={{ position: "relative", zIndex: 10 }}>
              <div className="d-flex align-items-center mb-3 text-primary">
                <i className="fas fa-calendar-check me-2"></i>
                <span className="fw-bold text-muted small text-uppercase" style={{ fontSize: '0.72rem' }}>
                  Controle de Assinatura
                </span>
              </div>

              <div className="row">
                <div className="col-12">
                  <label htmlFor="subscriptionEndDate" className="form-label small fw-bold text-dark mb-2">
                    Vencimento da Assinatura
                  </label>
                  <div className="w-100">
                    <ReactDatePicker
                      id="subscriptionEndDate"
                      className="form-control form-control-lg border-2 rounded-3 fw-bold text-primary"
                      dateFormat="dd/MM/yyyy"
                      locale="pt-BR"
                      onChange={(data) => setSubscriptionEndDate(data)}
                      onMonthChange={(data) => setSubscriptionEndDate(data)}
                      minDate={new Date()}
                      selected={subscriptionEndDate}
                      required
                    />
                  </div>
                  <small className="text-muted mt-2 d-block px-1" style={{ fontSize: '0.72rem' }}>
                    Após essa data, o acesso do cliente ao painel Alcon Auto será temporariamente bloqueado até a renovação.
                  </small>
                </div>
              </div>
            </div>

          </ModalBody>

          {/* Rodapé Consistente (Sem botões vermelhos perigosos de fechar) */}
          <ModalFooter className="border-0 pt-2 px-4 pb-4">
            <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="btn btn-outline-secondary btn-lg fw-bold rounded-3 px-4 order-1 order-sm-0"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm px-4"
                style={{ minWidth: '160px' }}
              >
                <i className="fas fa-save me-2"></i>
                Salvar
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
};

export default EditarEmpresa;